export type FetchState = "fetching" | "fetched" | "error";

export const ignore = (): any => ({});
export function fetchState(
  url: string,
  set: ({ state, data }: { state: FetchState; data?: any }) => void
) {
  set({ state: "fetching" });
  fetch(url)
    .then((r) => {
      if (!r.ok) throw new Error(`HTTP status ${r.status}`);
      return r.json();
    })
    .then((data) => set({ state: "fetched", data }))
    .catch(() => set({ state: "error", data: null }));
}
